function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 8.382H4.5V6.88H3V8.382ZM3 5.374V5.378L4.5 5.374C4.5 5.201 4.617 5.051 4.785 5.011L4.433 3.553C3.589 3.756 3 4.505 3 5.374ZM11 9.148V2.852C11 1.553 9.947 0.5 8.648 0.5H2.352C1.053 0.5 0 1.553 0 2.852V9.149C0 10.447 1.053 11.5 2.352 11.5H8.649C9.947 11.5 11 10.447 11 9.148ZM1.5 9.148V2.852C1.5 2.382 1.882 2 2.352 2H8.649C9.118 2 9.501 2.382 9.501 2.852V9.149C9.501 9.619 9.119 10.001 8.649 10.001H2.352C1.882 10 1.5 9.618 1.5 9.148ZM6.109 5H7.611V3.5H6.109V5ZM12 3.536V5.081C12.293 5.215 12.5 5.508 12.5 5.852V12.149C12.5 12.619 12.118 13.001 11.648 13.001H5.352C5.009 13.001 4.716 12.794 4.581 12.501H3.035C3.206 13.632 4.173 14.501 5.351 14.501H11.648C12.947 14.501 14 13.448 14 12.149V5.852C14 4.673 13.131 3.706 12 3.536Z",
  fill: "#9296AD"
});

function SvgCopyLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLight);
export default __webpack_public_path__ + "static/media/copy-light.87805b5a.svg";
export { ForwardRef as ReactComponent };